export default (route, mainEventName) => ({
    registrations: null,
    canRender: false,
    selectedIndex: [],
    selectAll: false,
    hasIndividualRegistrations: false,
    hasTeamPackageRegistrations: false,
    individualMessage: '',
    teamAdminMessageEnabled: true,
    teamAdminMessage: '',

    defaultMessage() {
        return `Thanks for registering for action photos at ${mainEventName}. Please check in with us at the event and have this QR code ready:`;
    },

    init() {
        this.individualMessage = this.defaultMessage();
        this.teamAdminMessage  = this.defaultMessage();

        window.addEventListener('open-activate-paid-customers-modal', () => this.loadDuplicates());

        window.addEventListener('close-activate-paid-customers-modal', () => {
            setTimeout(() => {
                this.registrations                = null;
                this.selectedIndex                = [];
                this.selectAll                    = false;
                this.canRender                    = false;
                this.hasDuplicates                = false;
                this.hasIndividualRegistrations   = false;
                this.hasTeamPackageRegistrations  = false;
                this.individualMessage            = this.defaultMessage();
                this.teamAdminMessageEnabled      = true;
                this.teamAdminMessage             = this.defaultMessage();
            }, 150);
        });

        this.$watch('selectAll', (value) => {
            if (value) {
                this.selectedIndex = Object.keys(this.registrations);

                return;
            }

            if (this.selectedIndex?.length === this.registrations?.length) {
                this.selectedIndex = [];
            }
        });

        this.$watch('selectedIndex', () => {
            this.selectAll = this.selectedIndex?.length === this.registrations?.length;
        });
    },

    async loadDuplicates() {
        const [individualCheck, teamCheck] = await Promise.all([
            this.$wire.hasIndividualRegistrations(),
            this.$wire.hasTeamPackageRegistrations(),
            fetch(route)
                .then(response => response.json())
                .then(data => this.set(data)),
        ]);

        this.hasIndividualRegistrations  = individualCheck;
        this.hasTeamPackageRegistrations = teamCheck;
        this.canRender = true;
    },

    set(data) {
        this.registrations = data;
    },

    getContent(registration) {
        return `Customer ${registration.customer_name} has ${registration.total} duplications for player ${registration.player_name}`;
    },

    activate(sendQrCode = false) {
        const idsToIgnore = this.getIds();

        this.$wire.activate({
            'sendQrCode': sendQrCode,
            'hasIndividualRegistrations': this.hasIndividualRegistrations,
            'individualMessage': this.individualMessage,
            'hasTeamPackageRegistrations': this.hasTeamPackageRegistrations,
            'teamAdminMessageEnabled': this.teamAdminMessageEnabled,
            'teamAdminMessage': this.teamAdminMessage,
        }, idsToIgnore);

        this.$dispatch('close-activate-paid-customers-modal');
    },

    getIds() {
        if (this.selectAll) return null;

        let registrations = this.registrations;
        registrations     = registrations.filter((_, index) => !this.selectedIndex.includes(index.toString()))

        return _.flatten(registrations.map((registration) => _.split(registration.registration_ids, ',')));
    },
})
